import { Hightlight } from '../../model/eform-type';
import { EFormHelper } from './helper';
export class SelectorHelper {
    selected = new Hightlight();
    helper = new EFormHelper();
    constructor() {
    }

    hightLight(section?: number, field?: number, $event?: any, table?: any) {
        this.selected.sectionIndex = section;
        this.selected.fieldSectionIndex = null;
        this.selected.fieldIndex = null;
        this.selected.tableIndex = null;

        // If table index is explicitly provided (not undefined), handle as table field selection
        if (table !== undefined && table !== null && table >= 0) {
          $event?.stopPropagation();
          this.selected.sectionIndex = null;
          this.selected.fieldSectionIndex = section;
          this.selected.fieldIndex = field;
          this.selected.tableIndex = table;
          return;
        }

        if (!$event && !field?.toString ) {
          this.selected.$event = null;
        } else if ($event?.target.id.startsWith('new-field') ) {
          $event.stopPropagation();
          this.selected.$event = $event;
        } else if ($event?.target.id === 'new-section') {
          this.selected.$event = $event;
          this.selected.sectionIndex = null;
        } else if ($event?.target.id.startsWith('new-table') || $event?.target.id.startsWith('field-set')) {
           $event.stopPropagation();
           this.selected.fieldIndex = field;
           this.selected.$event = $event;
           this.selected.sectionIndex = section;
           this.selected.fieldSectionIndex = null;
        } else {
          $event?.stopPropagation();
          this.selected.sectionIndex = null;
          this.selected.fieldSectionIndex = section;
          this.selected.fieldIndex = field;
          this.selected.tableIndex = (table === undefined) ? null : table ;
        }
      }

      hightLightDragDrop (section?: number, field?: number, table?: number) {
         this.selected.sectionIndex = null;
         this.selected.fieldSectionIndex = section;
         this.selected.fieldIndex = field;
         this.selected.tableIndex = (table !== undefined && table !== null) ? table : null;
      }

      clearSelector() {
         this.selected.$event = null;
         this.selected.fieldIndex = null;
         this.selected.fieldSectionIndex = null;
         this.selected.sectionIndex = null;
      }
}
